<template>
  <div class="BlockContents">
    <LoadingContent v-if="isLoading" />
    <template v-if="error">
      <p>{{ error }}</p>
    </template>

    <!-- <template v-if="element_type === 'paragraph--image'">
      <ParagraphImage :cms_response="CMS_response" />
    </template>-->
    <template v-else-if="element_type === 'paragraph--full_html'">
      <ParagraphFullhtml :cms_response="CMS_response" />
    </template>

    <template v-else-if="element_type === 'paragraph--heading'">
      <ParagraphHeading :cms_response="CMS_response" />
    </template>

    <!-- <template v-else-if="element_type === 'paragraph--hierarchical_block'">
      <ParagraphHierarchicalBlock :cms_response="CMS_response" />
    </template>

    <template v-else-if="element_type === 'paragraph--button'">
      <ParagraphButton :cms_response="CMS_response" />
    </template>

    <template v-else-if="element_type === 'paragraph--list'">
      <ParagraphList :cms_response="CMS_response" />
    </template>

    <template v-else-if="element_type === 'paragraph--imagetext'">
      <ParagraphImageText :cms_response="CMS_response" />
    </template> -->
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
// import ParagraphImage from "@/components/cms/elements/ParagraphImage";
import ParagraphFullhtml from "@/general/components/cms/elements/ParagraphFullhtml.vue";
import ParagraphHeading from "@/general/components/cms/elements/ParagraphHeading.vue";
// import ParagraphHierarchicalBlock from "@/components/cms/elements/ParagraphHierarchicalBlock";
// import ParagraphButton from "@/components/cms/elements/ParagraphButton";
// import ParagraphList from "@/components/cms/elements/ParagraphList";
// import ParagraphImageText from "@/components/cms/elements/ParagraphImageText";

import TopPageApi from "@/general/api/topPageApi";

@Options({
  name: "Cms",
  props: {
    location_code: { type: String, default: "" }
  },
  components: {
    // ParagraphImage,
    ParagraphFullhtml,
    ParagraphHeading
    // ParagraphHierarchicalBlock,
    // ParagraphButton,
    // ParagraphList,
    // ParagraphImageText,
  },
  methods: {
    async Readcms() {
      this.element_type = null;
      this.CMS_response = null;
      this.isLoading = true;
      await this.readcms();
      this.isLoading = false;
    }
  }
})
export default class BlockContents extends Vue {
  location_code!: string;

  error: string | null = null;
  element_type = null;
  CMS_response = null;
  ApiResponse = {
    data: {},
    isError: false
  };
  isLoading = true;

  async created() {
    await this.readcms();
    this.isLoading = false;
  }

  async readcms() {
    const APIres = await TopPageApi.getBlockContents({
      locationCode: this.location_code,
      contractID: null,
      courseID: null
    });
    this.ApiResponse.data = APIres;
    return this.setResponse(this.ApiResponse);
  }

  setResponse(obj: any) {
    if (
      !obj ||
      !obj.data ||
      !obj.data.data ||
      !obj.data.included ||
      !obj.data.included[0] ||
      !obj.data.data[0] ||
      !obj.data.data[0].relationships ||
      !obj.data.data[0].relationships.paragraphs ||
      !obj.data.data[0].relationships.paragraphs.data ||
      !obj.data.data[0].relationships.paragraphs.data[0] ||
      !obj.data.data[0].relationships.paragraphs.data[0].id
    ) {
      return;
    }
    // obj.data.data[0].relationships.paragraphs.data[0].idと、include[n].idを比較
    // 一致する物のみを画面に表示するために、include配列をフィルターする
    const data_id = obj.data.data[0].relationships.paragraphs.data[0].id;
    obj.data.included = obj.data.included.filter(
      (item: any) => item.id === data_id
    );

    if (obj.data.included.length !== 1) {
      this.error = "コンテンツの読み込みに失敗しました";
      return;
    }

    const type = obj.data.included[0].type;
    this.element_type = type;
    this.CMS_response = obj.data;
    this.$emit("hasContents", true);
  }
}
</script>

<style></style>
